module.exports = "tbody tr {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/serasa/component/serasa/serasa.component.scss
// module id = ./src/app/serasa/component/serasa/serasa.component.scss
// module chunks = main